function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  width: 40,
  height: 40,
  rx: 5,
  fill: "#FFC876"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57085 19.6299L2.09284 15.9498C2.03489 15.9109 1.99974 15.8552 1.99954 15.802L1.98043 10.8073C1.97996 10.6828 2.15856 10.6395 2.2934 10.7314L7.66897 14.3951C7.7251 14.4334 7.75946 14.4874 7.76072 14.5394L7.88227 19.5505C7.88531 19.6759 7.70701 19.7213 7.57085 19.6299Z",
  fill: "#F0BA69"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57085 1.31521L2.09284 4.99524C2.03489 5.03417 1.99974 5.08984 1.99954 5.14303L1.98043 10.1378C1.97996 10.2623 2.15856 10.3055 2.2934 10.2136L7.66897 6.54993C7.7251 6.51167 7.75946 6.45765 7.76072 6.40566L7.88227 1.39454C7.88531 1.26916 7.70701 1.22374 7.57085 1.31521Z",
  fill: "#F0BA69"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8611 19.6299L14.3831 15.9498C14.3252 15.9109 14.29 15.8552 14.2898 15.802L14.2707 10.8073C14.2702 10.6828 14.4488 10.6395 14.5837 10.7314L19.9593 14.3951C20.0154 14.4334 20.0497 14.4874 20.051 14.5394L20.1726 19.5505C20.1756 19.6759 19.9973 19.7213 19.8611 19.6299Z",
  fill: "#F0BA69"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8611 1.31521L14.3831 4.99524C14.3252 5.03417 14.29 5.08984 14.2898 5.14303L14.2707 10.1378C14.2702 10.2623 14.4488 10.3055 14.5837 10.2136L19.9593 6.54993C20.0154 6.51167 20.0497 6.45765 20.051 6.40566L20.1726 1.39454C20.1756 1.26916 19.9973 1.22374 19.8611 1.31521Z",
  fill: "#F0BA69"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1097 19.6299L26.6317 15.9498C26.5737 15.9109 26.5386 15.8552 26.5384 15.802L26.5193 10.8073C26.5188 10.6828 26.6974 10.6395 26.8322 10.7314L32.2078 14.3951C32.2639 14.4334 32.2983 14.4874 32.2995 14.5394L32.4211 19.5505C32.4241 19.6759 32.2458 19.7213 32.1097 19.6299Z",
  fill: "#F0BA69"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1097 1.31521L26.6317 4.99524C26.5737 5.03417 26.5386 5.08984 26.5384 5.14303L26.5193 10.1378C26.5188 10.2623 26.6974 10.3055 26.8322 10.2136L32.2078 6.54993C32.2639 6.51167 32.2983 6.45765 32.2995 6.40566L32.4211 1.39454C32.4241 1.26916 32.2458 1.22374 32.1097 1.31521Z",
  fill: "#F0BA69"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57085 20.069L2.09284 23.749C2.03489 23.788 1.99974 23.8436 1.99954 23.8968L1.98043 28.8916C1.97996 29.0161 2.15856 29.0593 2.2934 28.9674L7.66897 25.3037C7.7251 25.2655 7.75946 25.2114 7.76072 25.1594L7.88227 20.1483C7.88531 20.0229 7.70701 19.9775 7.57085 20.069Z",
  fill: "#F0BA69"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57085 38.3174L2.09284 34.6373C2.03489 34.5984 1.99974 34.5427 1.99954 34.4895L1.98043 29.4948C1.97996 29.3703 2.15856 29.327 2.2934 29.4189L7.66897 33.0826C7.7251 33.1209 7.75946 33.1749 7.76072 33.2269L7.88227 38.238C7.88531 38.3634 7.70701 38.4088 7.57085 38.3174Z",
  fill: "#F0BA69"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8611 20.069L14.3831 23.749C14.3252 23.788 14.29 23.8436 14.2898 23.8968L14.2707 28.8916C14.2702 29.0161 14.4488 29.0593 14.5837 28.9674L19.9593 25.3037C20.0154 25.2655 20.0497 25.2114 20.051 25.1594L20.1726 20.1483C20.1756 20.0229 19.9973 19.9775 19.8611 20.069Z",
  fill: "#F0BA69"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8611 38.3174L14.3831 34.6373C14.3252 34.5984 14.29 34.5427 14.2898 34.4895L14.2707 29.4948C14.2702 29.3703 14.4488 29.327 14.5837 29.4189L19.9593 33.0826C20.0154 33.1209 20.0497 33.1749 20.051 33.2269L20.1726 38.238C20.1756 38.3634 19.9973 38.4088 19.8611 38.3174Z",
  fill: "#F0BA69"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1097 20.069L26.6317 23.749C26.5737 23.788 26.5386 23.8436 26.5384 23.8968L26.5193 28.8916C26.5188 29.0161 26.6974 29.0593 26.8322 28.9674L32.2078 25.3037C32.2639 25.2655 32.2983 25.2114 32.2995 25.1594L32.4211 20.1483C32.4241 20.0229 32.2458 19.9775 32.1097 20.069Z",
  fill: "#F0BA69"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1097 38.3174L26.6317 34.6373C26.5737 34.5984 26.5386 34.5427 26.5384 34.4895L26.5193 29.4948C26.5188 29.3703 26.6974 29.327 26.8322 29.4189L32.2078 33.0826C32.2639 33.1209 32.2983 33.1749 32.2995 33.2269L32.4211 38.238C32.4241 38.3634 32.2458 38.4088 32.1097 38.3174Z",
  fill: "#F0BA69"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.623 10.7182L8.22453 14.4446C8.16675 14.4845 8.13231 14.5413 8.13327 14.5951L8.22203 19.59C8.22424 19.7143 8.40225 19.7557 8.53505 19.6627L13.8314 15.9536C13.8874 15.9144 13.921 15.8593 13.9212 15.8066L13.9345 10.7946C13.9348 10.6692 13.7571 10.6257 13.623 10.7182Z",
  fill: "#DFA856"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M13.623 10.2288L8.22453 6.50241C8.16675 6.46252 8.13231 6.40574 8.13327 6.35194L8.22203 1.35707C8.22424 1.23267 8.40225 1.19129 8.53505 1.28429L13.8314 4.99347C13.8874 5.03266 13.921 5.08777 13.9212 5.14038L13.9345 10.1524C13.9348 10.2778 13.7571 10.3214 13.623 10.2288Z",
  fill: "#DFA856"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9137 10.7182L20.5153 14.4446C20.4575 14.4845 20.4231 14.5413 20.424 14.5951L20.5128 19.59C20.515 19.7143 20.693 19.7557 20.8258 19.6627L26.1222 15.9536C26.1781 15.9144 26.2118 15.8593 26.2119 15.8066L26.2253 10.7946C26.2256 10.6692 26.0479 10.6257 25.9137 10.7182Z",
  fill: "#DFA856"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9137 10.2288L20.5153 6.50241C20.4575 6.46252 20.4231 6.40574 20.424 6.35194L20.5128 1.35707C20.515 1.23267 20.693 1.19129 20.8258 1.28429L26.1222 4.99347C26.1781 5.03266 26.2118 5.08777 26.2119 5.14038L26.2253 10.1524C26.2256 10.2778 26.0479 10.3214 25.9137 10.2288Z",
  fill: "#DFA856"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1618 10.7182L32.7633 14.4446C32.7056 14.4845 32.6711 14.5413 32.6721 14.5951L32.7609 19.59C32.7631 19.7143 32.9411 19.7557 33.0739 19.6627L38.3702 15.9536C38.4262 15.9144 38.4599 15.8593 38.46 15.8066L38.4733 10.7946C38.4736 10.6692 38.2959 10.6257 38.1618 10.7182Z",
  fill: "#DFA856"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1618 10.2288L32.7633 6.50241C32.7056 6.46252 32.6711 6.40574 32.6721 6.35194L32.7609 1.35707C32.7631 1.23267 32.9411 1.19129 33.0739 1.28429L38.3702 4.99347C38.4262 5.03266 38.4599 5.08777 38.46 5.14038L38.4733 10.1524C38.4737 10.2778 38.2959 10.3214 38.1618 10.2288Z",
  fill: "#DFA856"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M13.623 28.9807L8.22453 25.2544C8.16675 25.2145 8.13231 25.1577 8.13327 25.1039L8.22203 20.109C8.22424 19.9846 8.40225 19.9432 8.53505 20.0362L13.8314 23.7454C13.8874 23.7846 13.921 23.8397 13.9212 23.8923L13.9345 28.9044C13.9348 29.0298 13.7571 29.0733 13.623 28.9807Z",
  fill: "#DFA856"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M13.623 29.4056L8.22453 33.132C8.16675 33.1719 8.13231 33.2287 8.13327 33.2825L8.22203 38.2773C8.22424 38.4017 8.40225 38.4431 8.53505 38.3501L13.8314 34.6409C13.8874 34.6017 13.921 34.5466 13.9212 34.494L13.9345 29.4819C13.9348 29.3566 13.7571 29.313 13.623 29.4056Z",
  fill: "#DFA856"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9137 28.9807L20.5153 25.2544C20.4575 25.2145 20.4231 25.1577 20.424 25.1039L20.5128 20.109C20.515 19.9846 20.693 19.9432 20.8258 20.0362L26.1222 23.7454C26.1781 23.7846 26.2118 23.8397 26.2119 23.8923L26.2253 28.9044C26.2256 29.0298 26.0479 29.0733 25.9137 28.9807Z",
  fill: "#DFA856"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9137 29.4056L20.5153 33.132C20.4575 33.1719 20.4231 33.2287 20.424 33.2825L20.5128 38.2773C20.515 38.4017 20.693 38.4431 20.8258 38.3501L26.1222 34.6409C26.1781 34.6017 26.2118 34.5466 26.2119 34.494L26.2253 29.4819C26.2256 29.3566 26.0479 29.313 25.9137 29.4056Z",
  fill: "#DFA856"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1618 28.9807L32.7633 25.2544C32.7056 25.2145 32.6711 25.1577 32.6721 25.1039L32.7609 20.109C32.7631 19.9846 32.9411 19.9432 33.0739 20.0362L38.3702 23.7454C38.4262 23.7846 38.4599 23.8397 38.46 23.8923L38.4733 28.9044C38.4737 29.0298 38.2959 29.0733 38.1618 28.9807Z",
  fill: "#DFA856"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1618 29.4056L32.7633 33.132C32.7056 33.1719 32.6711 33.2287 32.6721 33.2825L32.7609 38.2773C32.7631 38.4017 32.9411 38.4431 33.0739 38.3501L38.3702 34.6409C38.4262 34.6017 38.4599 34.5466 38.46 34.494L38.4733 29.4819C38.4736 29.3566 38.2959 29.313 38.1618 29.4056Z",
  fill: "#DFA856"
});

function SvgTileYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileYellow);
export default __webpack_public_path__ + "static/media/tile-yellow.9d5bb524.svg";
export { ForwardRef as ReactComponent };